import React from "react";

const VendorPartnership = () => {
  return (
    <div className="min-h-screen h-full bg-natural-100">
      <main className="max-w-screen-xl mx-auto">
        <div>
          Vendor Partnerships
        </div>
      </main>
    </div>
  );
};

export default VendorPartnership;
